<template>
  <div class="layout-index-carousel">
    <slot></slot>
    <div class="dots">
      <div class="dot" :class="[{ active: current === index }]" v-for="(slide, index) in slides" :key="index"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slides: [],
      current: 0
    }
  },
  methods: {
    updateActive() {
      this.slides.forEach((slide, index) => {
        if (index !== this.current) {
          slide.classList.remove('active')
        } else {
          slide.classList.add('active')
        }
      })
    },
    next() {
      if (this.current !== this.slides.length - 1) {
        this.current++
      } else {
        this.current = 0
      }
      this.updateActive()
    },
    startTimer() {
      setInterval(() => {
        this.next()
      }, 3000)
    }
  },
  mounted() {
    this.slides = [...this.$el.querySelectorAll('section')]
    this.updateActive()
    this.startTimer()
  }
}
</script>

<style lang="scss">
.layout-index-carousel {
  height: 43.75em;
  position: relative;
  color: #fff;
  text-align: center;
  background: #000;
  & > section {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 0;
    padding-top: 4em;
    opacity: 0;
    visibility: hidden;
    transition: 0.5s;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      object-fit: cover;
      z-index: -1;
      opacity: 0.8;
    }
    &.active {
      opacity: 1;
      visibility: visible;
    }
  }
  .dot {
    width: 10px;
    height: 10px;
    border: solid 2px;
    border-radius: 50%;
    margin: 3px;
    transition: 0.3s;
    &.active {
      background: currentColor;
    }
  }
  .dots {
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    align-items: flex-end;
    padding: 2.5em;
    pointer-events: none;
  }
  .subtitle {
    margin: 1em 0;
  }
  .ui-button {
    margin-top: 2em;
  }
}

@media screen and (max-width: 767px) {
  .layout-index-carousel {
    & > section {
      padding: 15px;
      padding-top: 4em;
    }
    .title {
      font-size: 42px;
    }
  }
}
</style>
